<template>
  <div>
    <div class="edit">
      <div class="head">
        <p class="breadcrumb">
          <span class="tem" @click="back">
            模板库
            <span class="right">></span>
          </span>
          <span class="new">{{isNew?'新增模板':name}}</span>
        </p>
        <zt-button type="primary" @click="save" class="save">保存</zt-button>
      </div>

      <zt-title>模板名称</zt-title>
      <limit-input
        type="text"
        placeholder="请输入模板名称"
        v-model="name"
        :maxlength="10"
        :showLimit="true"
      ></limit-input>

      <zt-title>自定义模板</zt-title>
      <pack>
        <div
          class="tem-bar"
          :class="activeModuleId==idx?'tem-bar-active':''"
          v-for="(item,idx) in formatModuleList"
          :key="idx"
          @click="addModule(item,idx)"
          @mouseenter="barMouseenter(idx)"
          @mouseleave="barMouseLeave(idx)"
        >
          <div class="bar-inner"></div>
          <svg-icon
            :icon="`${activeModuleId==idx?'tem_add_a':hoverModuleId==idx?'tem_add_h':'tem_add'}`"
          ></svg-icon>
          <span>{{item.name}}</span>
        </div>
      </pack>

      <div class="edit-main">
        <!-- 显示模块 -->
        <div class="template-view" id="template_view">
          <head-module
            @moveUp="moveUp"
            @moveDown="moveDown"
            @edit="edit"
            @del="del"
            :info="headModuleData"
            idx="head_module"
          />
          <div class="scoll-view" ref="templatView">
            <template v-for="(item,idx) in viewModuleList">
              <component
                @moveUp="moveUp"
                @moveDown="moveDown"
                @edit="edit"
                @del="del"
                :info="item"
                :hasRecommend="hasRecommend"
                :moduleLength="viewModuleList.length"
                :key="item.module+idx"
                :idx="idx"
                :is="item.moduleType"
                :mouduleName="item.module"
              ></component>
            </template>
          </div>
          <nav-module
            @moveUp="moveUp"
            :info="navModuleData"
            :list="bottom_tab_list"
            @moveDown="moveDown"
            @edit="edit"
            @del="del"
            idx="nav_module"
          />
        </div>

        <!-- 编辑模块 -->
        <div class="template-edit" v-if="editTemplate.name">
          <p class="title" v-if="editTemplate.name">
            {{editTemplate.name}}
            <span class="tips" v-if="editTemplate.name=='nav_module'">最多5个图标</span>
          </p>
          <hr v-if="editTemplate.name" />

          <!-- 导航栏编辑 start -->
          <div class="head-edit" v-if="editTemplate.name=='导航栏'">
            <span>背景色</span>
            <el-color-picker
              :predefine="predefineColors"
              v-model="editTemplate.toolbar_background_color"
            ></el-color-picker>
          </div>
          <!-- 导航栏编辑 end -->

          <!-- 拼多多京东编辑 start -->
          <div
            class="pdd-edit"
            v-if="editTemplate.module=='pdd_module'||editTemplate.module=='jd_module'"
          >
            <el-form label-width="110px" label-position="left">
              <el-form-item label="标题">
                <limit-input
                  placeholder="请输入标题"
                  v-model="editTemplate.items[0].title"
                  :maxlength="10"
                  :showLimit="true"
                ></limit-input>
              </el-form-item>
              <el-form-item label="辅助信息">
                <limit-input
                  placeholder="请输入辅助信息"
                  v-model="editTemplate.items[0].subTitle"
                  :maxlength="6"
                  :showLimit="true"
                ></limit-input>
              </el-form-item>
            </el-form>
          </div>
          <!-- 拼多多京东编辑 end -->

          <!-- 双拼编辑 -->
          <div class="double-edit" v-if="editTemplate.moduleType=='double-module'">
            <el-form label-width="110px" label-position="left">
              <el-form-item label="拼多多商城标题">
                <limit-input
                  placeholder="请输入标题"
                  v-model="editTemplate.items[0].title"
                  :maxlength="6"
                  :showLimit="true"
                ></limit-input>
              </el-form-item>
              <el-form-item label="京东商城标题">
                <limit-input
                  placeholder="请输入辅助信息"
                  v-model="editTemplate.items[1].title"
                  :maxlength="6"
                  :showLimit="true"
                ></limit-input>
              </el-form-item>
            </el-form>
          </div>
          <!-- 双拼编辑 end -->

          <!-- 拼图编辑 start -->
          <div class="puzzle-edit" v-if="editTemplate.moduleType=='puzzle-module'">
            <div v-for="(item,idx) in editTemplate.items" :key="idx" class="puzzle-item">
              <p>{{`拼图${idx==0?'一':idx==1?'二':idx==2?'三':'四'}`}}</p>
              <el-form label-position="left" label-width="110px">
                <el-form-item label="标题">
                  <limit-input
                    type="text"
                    v-model="item.title"
                    placeholder="请输入标题"
                    :maxlength="editTemplate.cmsModuleName=='puzzle_module_0'||editTemplate.cmsModuleName=='puzzle_module_2'?8:6"
                    :showLimit="true"
                  ></limit-input>
                </el-form-item>
                <el-form-item label="辅助文案">
                  <limit-input
                    type="text"
                    v-model="item.subTitle"
                    placeholder="请输入辅助信息"
                    :maxlength="10"
                    :showLimit="true"
                  ></limit-input>
                </el-form-item>
                <el-form-item label="辅助文案二" v-if="editTemplate.cmsModuleName == 'puzzle_module_3'">
                  <limit-input
                    type="text"
                    v-model="item.buyNow"
                    placeholder="请输入辅助文案二"
                    :maxlength="10"
                    :showLimit="true"
                  ></limit-input>
                </el-form-item>
                <el-form-item label="跳转链接">
                  <div class="link-input" @click="showUrlDialog(item,idx)">
                    <div
                      class="text"
                      :class="`${item.url==''?'text-dis':''}`"
                    >{{item.url||'请输入跳转链接'}}</div>
                    <svg-icon icon="textEdit" size="20" />
                  </div>
                </el-form-item>
              </el-form>
              <div class="upload-box" v-for="(imgItem,imgIdx) in item.imgs" :key="imgIdx">
                <span class="text">{{`图片${imgIdx+1==1?'一':imgIdx+1==2?'二':'三'}`}}</span>
                <img-upload
                  :ref="`upload${imgIdx}`"
                  text="更换图片"
                  :idx="imgIdx"
                  :data="{idx}"
                  :src="imgItem"
                  @changeFace="changeImg"
                ></img-upload>
              </div>
            </div>
          </div>
          <!-- 拼图编辑 end -->

          <!-- 底部导航栏编辑 start -->
          <div class="nav-edit" v-if="editTemplate.moduleType=='nav_module'">
            <el-table :data="bottom_tab_list">
              <el-table-column label="图标选中" width="100">
                <template slot-scope="scope">
                  <img-upload
                    :ref="`upload${scope.row.tab_title}`"
                    text="更换图片"
                    :idx="'tab_check_img'"
                    :data="scope"
                    :src="scope.row.tab_check_img"
                    :noText="true"
                    @changeFace="changeTabIcon"
                  ></img-upload>
                </template>
              </el-table-column>
              <el-table-column label="图标未选中" width="100">
                <template slot-scope="scope">
                  <img-upload
                    :ref="`upload${scope.row.tab_title}`"
                    text="更换图片"
                    :idx="'tab_normal_img'"
                    :data="scope"
                    :src="scope.row.tab_normal_img"
                    :noText="true"
                    @changeFace="changeTabIcon"
                  ></img-upload>
                </template>
              </el-table-column>
              <el-table-column label="文案">
                <template slot-scope="scope">
                  <limit-input :showLimit="true" v-model="scope.row.tab_title" :maxlength="5"></limit-input>
                </template>
              </el-table-column>
              <el-table-column label="跳转链接">
                <template slot-scope="scope">
                  <div
                    class="link"
                    :class="scope.$index==0?'disabled':''"
                    @click="showUrlDialog(scope.row,scope.$index)"
                  >
                    {{scope.row.tab_url}}
                    <svg-icon icon="textEdit" size="20" />
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="35">
                <template slot-scope="scope">
                  <div class="del">
                    <zt-button
                      @click="delNav(scope)"
                      :disabled="(scope.row.tab_symbol=='home'&&scope.$index==0)||bottom_tab_list.length<4"
                    >
                      <i class="el-icon-delete"></i>
                    </zt-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <zt-button icon="el-icon-plus" @click="addTab" :disabled="bottom_tab_list.length>=5">新增</zt-button>
          </div>
          <!-- 底部导航栏编辑 end -->
        </div>
      </div>
    </div>
    <!-- 链接弹窗 -->
    <!-- <setting-link-dialog
      v-model="urlDialogVisible"
      :url="editInfo.url||editInfo.tab_url"
      @change="onUrlChange"
      class="ignore-elements"
    /> -->
    <CmsEntrySelectPopup 
      :visible.sync="urlDialogVisible"
      :value="editInfo.url||editInfo.tab_url"
      @confirm="onUrlChange"
    />
  </div>
</template>

<script>
import html2canvas from 'html2canvas';
import limitInput from './limitInput';
import puzzleModule from './puzzleModule';
import pitModule from './pitModule';
import headModule from './headModule';
import navModule from './navModule';
import doubleModule from './doubleModule';
import imgUpload from '@cps/Upload/imgUpload';
import { getToken, getRoles } from '@/utils/auth'; // getToken from cookie
import { mapGetters } from 'vuex';
import { pictureAdd } from '@/api/upload';
// import SettingLinkDialog from "@/views/cmsWebSite/components/config/advert/components/SettingLinkDialog";
import {
  taoke_plugin_app_theme_add,
  taoke_plugin_app_theme_list,
  taoke_plugin_app_theme_edit,
  admin_plugin_app_theme_add,
  admin_plugin_app_theme_list,
  admin_plugin_app_theme_edit
} from '@/api/extension';

import { CmsEntrySelectPopup } from '@/components/CmsEntrySelect'

export default {
  name: 'tempaleEdit',
  components: {
    limitInput,
    puzzleModule,
    pitModule,
    headModule,
    navModule,
    imgUpload,
    // SettingLinkDialog,
    doubleModule,
    CmsEntrySelectPopup,
  },
  watch: {
    editTemplateData: {
      deep: true,
      immediate: true,
      handler(value) {
        this.parseTemplateJson(value);
      },
    },
  },
  data: () => ({
    role: getRoles(),
    editInfo: {},
    urlDialogVisible: false,
    isNew: false,
    id: '',
    imgUrl: '',
    thum_image: '',
    name: '', //模板名称
    //头部数据
    headModuleData: {
      moduleType: 'head_module',
      toolbar_background_color: '#FFFFFF',
      name: '导航栏',
    },
    //底部导航数据
    navModuleData: {
      moduleType: 'nav_module',
      name: '底部导航栏',
    },
    // 底部导航栏数据
    bottom_tab_list: [
      {
        tab_symbol: 'home',
        tab_normal_img:
          'https://www.zhutui.cn/images/appicon/icon_shouye_n@3x.png',
        tab_check_img:
          'https://www.zhutui.cn/images/appicon/icon_shouye_s@3x.png',
        tab_title: '首页',
        tab_url: '/',
      },
      {
        tab_symbol: 'category',
        tab_normal_img:
          'https://www.zhutui.cn/images/appicon/icon_fenlei_n@3x.png',
        tab_check_img:
          'https://www.zhutui.cn/images/appicon/icon_fenlei_s@3x.png',
        tab_title: '分类',
        tab_url: '/category',
      },
      {
        tab_symbol: 'ranking',
        tab_normal_img:
          'https://www.zhutui.cn/images/appicon/icon_baokuan_n@3x.png',
        tab_check_img:
          'https://www.zhutui.cn/images/appicon/icon_baokuan_s@3x.png',
        tab_title: '爆款排行',
        tab_url: '/ranking',
      },
      {
        tab_symbol: 'user',
        tab_normal_img:
          'https://www.zhutui.cn/images/appicon/icon_wode_n@3x.png',
        tab_check_img:
          'https://www.zhutui.cn/images/appicon/icon_wode_s@3x.png',
        tab_title: '我的',
        tab_url: '/user',
      },
    ],
    //模块显示列表
    viewModuleList: [],
    //模块变价数据
    editTemplate: {},
    //预设颜色
    predefineColors: ['#FF6766', '#FF9C00', '#8C41DF'],
    hoverModuleId: -1,
    activeModuleId: -1,
    // 模块转换对照,解析模板时添加到接口返回的模板里
    templateParseList: {
      banner_module: {
        height: 154,
        name: '轮播图',
        module: 'banner_module',
        moduleType: 'pit-module',
      },
      search_module: {
        height: 52,
        name: '搜索框',
        module: 'search_module',
        moduleType: 'pit-module',
      },
      sale_module: {
        height: 187,
        name: '限时抢购',
        module: 'sale_module',
        moduleType: 'pit-module',
      },
      puzzle_module_0: {
        height: 118,
        name: '拼图(两列)',
        module: 'puzzle_module',
        moduleType: 'puzzle-module',
      },
      puzzle_module_1: {
        height: 114.5,
        name: '拼图(三列)',
        module: 'puzzle_module',
        moduleType: 'puzzle-module',
      },
      puzzle_module_2: {
        height: 225,
        name: '拼图(两行两列)',
        module: 'puzzle_module',
        moduleType: 'puzzle-module',
      },
      puzzle_module_3: {
        height: 224,
        name: '拼图(左一右二)',
        module: 'puzzle_module',
        moduleType: 'puzzle-module',
      },
      command_module: {
        height: 232,
        name: '为你推荐',
        module: 'command_module',
        moduleType: 'pit-module',
      },
      pdd_module: {
        height: 76,
        name: '拼多多',
        module: 'pdd_module',
        moduleType: 'pit-module',
      },
      jd_module: {
        height: 76,
        name: '京东',
        module: 'jd_module',
        moduleType: 'pit-module',
      },
      doubleShop: {
        name: '商城',
        height: 76,
        module: 'double_module',
        moduleType: 'double-module',
      },
    },
    // 双拼模块数据
    doubleModuleData: {
      name: '商城',
      height: 76,
      module: 'double_module',
      moduleType: 'double-module',
      cmsModuleName: 'doubleShop',
      type: 'container-twoColumn',
      style: {
        margin: [10, 16, 10, 16],
        hGap: 12,
        vGap: 0,
      },
      items: [
        {
          type: 'cell-PddJdItem-Two',
          title: '拼多多商城',
          url: '/pdd',
        },
        {
          type: 'cell-PddJdItem-Two',
          title: '京东商城',
          url: '/jd',
        },
      ],
    },
    //模块列表
    moduleList: [
      {
        height: 154,
        name: '轮播图',
        cmsModuleName: 'banner_module',
        module: 'banner_module',
        moduleType: 'pit-module',
        type: 'container-banner',
        style: {
          itemRatio: 2.5,
          indicatorImg1: 'https://jk.zhutui.cn/images/app/indicatorImg1@3x.png',
          indicatorImg2: 'https://jk.zhutui.cn/images/app/indicatorImg2@3x.png',
          indicatorGap: 6,
          autoScroll: 4000,
          infinite: 'true',
          indicatorMargin: 8,
          hGap: 8,
        },
      },
      {
        height: 52,
        name: '搜索框',
        cmsModuleName: 'search_module',
        module: 'search_module',
        moduleType: 'pit-module',
        type: 'container-sticky',
        style: {
          sticky: 'start',
          'background-color': '#FFFFFF', // 背景颜色（框架有奇怪Bug，布局和组件都需要设置）
        },
        items: [
          {
            type: 'cell-Search',
            style: {
              'background-color': '#FFFFFF', // 背景颜色（框架有奇怪Bug，布局和组件都需要设置）
            },
            searchFrameColor: '#ECEFF1', // 搜索框内颜色
            hint: '请输入关键词、淘口令以搜索优惠券', // 提示文字
          },
        ],
      },
      {
        height: 187,
        name: '限时抢购',
        cmsModuleName: 'sale_module',
        module: 'sale_module',
        moduleType: 'pit-module',
        type: 'container-oneColumn',
        style: {
          margin: [
            // 外边距
            10,
            16,
            10,
            16,
          ],
        },
        items: [
          {
            type: 'cell-FlashSale',
            style: {
              'background-color': '#FFFFFF', // 背景色
            },
            cornerRadius: [
              // 圆角
              4,
              4,
              4,
              4,
            ],
            flashSale: {
              // 限时抢购数据
              sallingItmes: [], // 限时抢购商品
            },
          },
        ],
      },
      {
        height: 76,
        name: '拼多多',
        module: 'pdd_module',
        moduleType: 'pit-module',
        cmsModuleName: 'pdd_module',
        type: 'container-oneColumn',
        style: {
          margin: [10, 16, 10, 16],
        },
        items: [
          {
            type: 'cell-PddJdItem-One',
            url: '/pdd',
            title: '拼多多商城',
            subTitle: '立即进入>',
          },
        ],
      },
      {
        height: 76,
        name: '京东',
        module: 'jd_module',
        moduleType: 'pit-module',
        cmsModuleName: 'jd_module',
        type: 'container-oneColumn',
        style: {
          margin: [10, 16, 10, 16],
        },
        items: [
          {
            type: 'cell-PddJdItem-One',
            url: '/jd',
            title: '京东商城',
            subTitle: '立即进入>',
          },
        ],
      },
      {
        height: 118,
        name: '拼图(两列)',
        module: 'puzzle_module',
        moduleType: 'puzzle-module',
        cmsModuleName: 'puzzle_module_0',
        type: 'container-twoColumn',
        style: {
          margin: [
            // 外间距
            10, // 上
            16, // 右
            10, // 下
            16, // 左
          ],
          hGap: 1, // 水平方向组件距离
          vGap: 1, // 垂直方向组件距离
        },
        items: [
          {
            type: 'cell-BrandItem', // 组件
            style: {
              padding: [
                // 内边距
                8,
                12,
                8,
                12,
              ],
              'background-color': '#FFFFFF', // 背景色
            },
            cornerRadius: [
              // 圆角（根据组件位置设定哪一个角圆角）
              4,
              0,
              4,
              0,
            ],
            title: '9块9包邮',
            subTitle: '省钱不只是一点点',
            imgs: [
              'https://jk.zhutui.cn/cms/public/images/c1.png',
              'https://jk.zhutui.cn/cms/public/images/c2.png',
              'https://jk.zhutui.cn/cms/public/images/c3.png',
            ],
            url: '/channel/0',
          },
          {
            type: 'cell-BrandItem', // 组件
            style: {
              padding: [
                // 内边距
                8,
                12,
                8,
                12,
              ],
              'background-color': '#FFFFFF', // 背景色
            },
            cornerRadius: [
              // 圆角（根据组件位置设定哪一个角圆角）
              0,
              0,
              0,
              0,
            ],
            title: '人工精选',
            subTitle: '为你精选热卖品牌',
            imgs: [
              'https://jk.zhutui.cn/cms/public/images/c4.png',
              'https://jk.zhutui.cn/cms/public/images/c5.png',
              'https://jk.zhutui.cn/cms/public/images/c6.png',
            ],
            url: '/channel/1',
          },
        ],
      },
      {
        height: 114.5,
        name: '拼图(三列)',
        module: 'puzzle_module',
        moduleType: 'puzzle-module',
        cmsModuleName: 'puzzle_module_1',
        type: 'container-threeColumn',
        style: {
          margin: [
            // 外间距
            10, // 上
            16, // 右
            10, // 下
            16, // 左
          ],
          hGap: 1, // 水平方向组件距离
          vGap: 1, // 垂直方向组件距离
        },
        items: [
          {
            type: 'cell-BrandItem', // 组件
            style: {
              padding: [
                // 内边距
                8,
                12,
                8,
                12,
              ],
              'background-color': '#FFFFFF', // 背景色
            },
            cornerRadius: [
              // 圆角（根据组件位置设定哪一个角圆角）
              4,
              0,
              4,
              0,
            ],
            title: '9块9包邮',
            subTitle: '省钱不只是一点点',
            imgs: [
              'https://jk.zhutui.cn/cms/public/images/c1.png',
              'https://jk.zhutui.cn/cms/public/images/c2.png',
            ],
            url: '/channel/0',
          },
          {
            type: 'cell-BrandItem', // 组件
            style: {
              padding: [
                // 内边距
                8,
                12,
                8,
                12,
              ],
              'background-color': '#FFFFFF', // 背景色
            },
            cornerRadius: [
              // 圆角（根据组件位置设定哪一个角圆角）
              0,
              0,
              0,
              0,
            ],
            title: '人工精选',
            subTitle: '为你精选热卖品牌',
            imgs: [
              'https://jk.zhutui.cn/cms/public/images/c3.png',
              'https://jk.zhutui.cn/cms/public/images/c4.png',
            ],
            url: '/channel/1',
          },
          {
            type: 'cell-BrandItem', // 组件
            style: {
              padding: [
                // 内边距
                8,
                12,
                8,
                12,
              ],
              'background-color': '#FFFFFF', // 背景色
            },
            cornerRadius: [
              // 圆角（根据组件位置设定哪一个角圆角）
              0,
              4,
              0,
              4,
            ],
            title: '品牌爆品',
            subTitle: '精选最热单品',
            imgs: [
              'https://jk.zhutui.cn/cms/public/images/c5.png',
              'https://jk.zhutui.cn/cms/public/images/c6.png',
            ],
            url: '/category/mama_channel_3',
          },
        ],
      },
      {
        height: 225,
        name: '拼图(两行两列)',
        module: 'puzzle_module',
        moduleType: 'puzzle-module',
        type: 'container-twoColumn',
        style: {
          margin: [
            // 外间距
            10, // 上
            16, // 右
            10, // 下
            16, // 左
          ],
          hGap: 1, // 水平方向组件距离
          vGap: 1, // 垂直方向组件距离
        },
        cmsModuleName: 'puzzle_module_2',
        items: [
          {
            type: 'cell-BrandItem',
            style: {
              padding: [
                // 内边距
                8,
                12,
                8,
                12,
              ],
              'background-color': '#FFFFFF', // 背景色
            },
            cornerRadius: [
              // 圆角（根据组件位置设定哪一个角圆角）
              4,
              0,
              0,
              0,
            ],
            title: '9块9包邮',
            subTitle: '省钱不只是一点点',
            imgs: [
              'https://jk.zhutui.cn/cms/public/images/c1.png',
              'https://jk.zhutui.cn/cms/public/images/c2.png',
              'https://jk.zhutui.cn/cms/public/images/c3.png',
            ],
            url: '/channel/0',
          },
          {
            type: 'cell-BrandItem',
            style: {
              padding: [
                // 内边距
                8,
                12,
                8,
                12,
              ],
              'background-color': '#FFFFFF', // 背景色
            },
            cornerRadius: [
              // 圆角（根据组件位置设定哪一个角圆角）
              0,
              4,
              0,
              0,
            ],
            title: '人工精选',
            subTitle: '为你精选热卖品牌',
            imgs: [
              'https://jk.zhutui.cn/cms/public/images/c4.png',
              'https://jk.zhutui.cn/cms/public/images/c5.png',
              'https://jk.zhutui.cn/cms/public/images/c6.png',
            ],
            url: '/channel/1',
          },
          {
            type: 'cell-BrandItem',
            style: {
              padding: [
                // 内边距
                8,
                12,
                8,
                12,
              ],
              'background-color': '#FFFFFF', // 背景色
            },
            cornerRadius: [
              // 圆角（根据组件位置设定哪一个角圆角）
              0,
              0,
              4,
              0,
            ],
            title: '品牌爆品',
            subTitle: '精选最热单品',
            imgs: [
              'https://jk.zhutui.cn/cms/public/images/c1.png',
              'https://jk.zhutui.cn/cms/public/images/c2.png',
              'https://jk.zhutui.cn/cms/public/images/c3.png',
            ],
            url: '/category/mama_channel_3',
          },
          {
            type: 'cell-BrandItem',
            style: {
              padding: [
                // 内边距
                8,
                12,
                8,
                12,
              ],
              'background-color': '#FFFFFF', // 背景色
            },
            cornerRadius: [
              // 圆角（根据组件位置设定哪一个角圆角）
              0,
              0,
              0,
              4,
            ],
            title: '聚划算',
            subTitle: '高性价比商品',
            imgs: [
              'https://jk.zhutui.cn/cms/public/images/c4.png',
              'https://jk.zhutui.cn/cms/public/images/c5.png',
              'https://jk.zhutui.cn/cms/public/images/c6.png',
            ],
            url: '/category/tag_1',
          },
        ],
      },
      {
        height: 224,
        type: 'container-onePlusN',
        style: {
          margin: [
            // 外间距
            10, // 上
            16, // 右
            10, // 下
            16, // 左
          ],
          aspectRatio: '1.75', // 宽高比
          cols: [
            // 宽度比(左边宽度与右边整体宽度)
            50,
          ],
        },
        items: [
          {
            type: 'cell-BrandFeatured', // 组件，与前面items类型不同
            style: {
              padding: [
                // 内边距
                8,
                12,
                8,
                12,
              ],
              margin: [
                // 外间距
                0,
                1,
                0,
                0,
              ],
              'background-color': '#FFFFFF', // 背景颜色
            },
            cornerRadius: [
              //     圆角(左边item)
              4,
              0,
              4,
              0,
            ],
            title: '清仓好货',
            subTitle: '便宜实惠不买后悔',
            buyNow: '立即购买>',
            imgs: ['https://jk.zhutui.cn/cms/public/images/c7.png'],
            url: '/category/mama_channel_2',
          },
          {
            type: 'cell-BrandItem', // 右边两个item与左边不一样
            style: {
              padding: [8, 12, 8, 12],
              'background-color': '#FFFFFF',
            },
            cornerRadius: [
              // 圆角(右上角item)
              0,
              4,
              0,
              0,
            ],
            title: '9块9包邮',
            subTitle: '省钱不只是一点点',
            imgs: [
              'https://jk.zhutui.cn/cms/public/images/c4.png',
              'https://jk.zhutui.cn/cms/public/images/c5.png',
              'https://jk.zhutui.cn/cms/public/images/c6.png',
            ],
            url: '/channel/0',
          },
          {
            type: 'cell-BrandItem',
            style: {
              padding: [8, 12, 8, 12],
              'background-color': '#FFFFFF',
            },
            cornerRadius: [
              // 圆角(右下角item)
              0,
              0,
              0,
              4,
            ],
            title: '人工精选',
            subTitle: '为你精选热卖品牌',
            imgs: [
              'https://jk.zhutui.cn/cms/public/images/c1.png',
              'https://jk.zhutui.cn/cms/public/images/c2.png',
              'https://jk.zhutui.cn/cms/public/images/c3.png',
            ],
            url: '/channel/1',
          },
        ],
        name: '拼图(左一右二)',
        cmsModuleName: 'puzzle_module_3',
        module: 'puzzle-module',
        moduleType: 'puzzle-module',
      },
      {
        height: 232,
        name: '为你推荐',
        id: 'recommend',
        type: 'container-oneColumn',
        cmsModuleName: 'command_module',
        load: 'recommend',
        header: {
          type: 'cell-Header',
          title: '为你推荐', // 头部文字
        },
        loadType: 1, // 异步加载的方式，-1表示需要异步加载，1表示需要异步加载且有分页
        module: 'command_module',
        moduleType: 'pit-module',
      },
    ],
  }),
  props: {
    editTemplateData: Object,
  },
  computed: {
    ...mapGetters(['pluginFlashsale']),
    // 是否购买了限时抢购插件,管理中心不作限制
    isBuy: (vm) =>
      vm.pluginFlashsale.plugin_flashsale_expires_at >
        parseInt(Date.now() / 1000) || getRoles() == 'admin',
    formatModuleList: (vm) => {
      return vm.moduleList
        .filter((item) => {
          if (!vm.isBuy) {
            return item.name != '限时抢购';
          } else {
            return true;
          }
        })
        .filter((item) => {
          if (vm.hasRecommend) {
            return item.id != 'recommend';
          } else {
            return true;
          }
        })
        .filter((item) => {
          if (vm.hasPdd) {
            return item.module != 'pdd_module';
          } else {
            return true;
          }
        })
        .filter((item) => {
          if (vm.hasJd) {
            return item.module != 'jd_module';
          } else {
            return true;
          }
        })
        .filter((item) => {
          if (vm.hasDouble) {
            return item.module != 'jd_module' && item.module != 'pdd_module';
          } else {
            return true;
          }
        });
    },
    // 判断列表中是否有双拼
    hasDouble: (vm) => {
      let flag = false;
      vm.viewModuleList.map((arr) => {
        if (arr.module == 'double_module') {
          flag = true;
        }
      });
      return flag;
    },
    // 判断列表中是否有拼多多
    hasPdd: (vm) => {
      let flag = false;
      vm.viewModuleList.map((arr) => {
        if (arr.module == 'pdd_module') {
          flag = true;
        }
      });
      return flag;
    },
    // 判断列表中是否有京东
    hasJd: (vm) => {
      let flag = false;
      vm.viewModuleList.map((arr) => {
        if (arr.module == 'jd_module') {
          flag = true;
        }
      });
      return flag;
    },
    // 判断列表中是否已有为你推荐
    hasRecommend: (vm) => {
      let flag = false;
      vm.viewModuleList.map((arr) => {
        if (arr.id == 'recommend') {
          flag = true;
        }
      });
      return flag;
    },
  },
  methods: {
    // 判断列表中是否已有拼多多或京东模块，返回在列表中的位置
    hasShopModule() {
      let index = -1;
      this.viewModuleList.map((arr, idx) => {
        if (
          arr.cmsModuleName == 'pdd_module' ||
          arr.cmsModuleName == 'jd_module'
        ) {
          index = idx;
        }
      });
      return index;
    },
    // 接口获取
    plugin_app_theme_add(param) {
      if (this.role == 'admin') {
        return admin_plugin_app_theme_add(param);
      } else {
        return taoke_plugin_app_theme_add(param);
      }
    },
    plugin_app_theme_edit(param) {
      if (this.role == 'admin') {
        return admin_plugin_app_theme_edit(param);
      } else {
        return taoke_plugin_app_theme_edit(param);
      }
    },
    plugin_app_theme_list(param) {
      if (this.role == 'admin') {
        return admin_plugin_app_theme_list(param);
      } else {
        return taoke_plugin_app_theme_list(param);
      }
    },
    //  底部导航栏新增tab
    addTab() {
      this.bottom_tab_list.push({
        tab_symbol: 'other',
        tab_normal_img:
          'https://www.zhutui.cn/images/appicon/icon_wode_n@3x.png',
        tab_check_img:
          'https://www.zhutui.cn/images/appicon/icon_wode_s@3x.png',
        tab_title: '其他',
        tab_url: '',
      });
    },
    //  底部导航栏tab删除
    delNav(scope) {
      if (scope.row.tab_symbol == 'home' || this.bottom_tab_list.length < 4)
        return;
      this.bottom_tab_list.splice(scope.$index, 1);
    },
    // 更换底部图片
    changeTabIcon(filePath, idx, data) {
      data.row[idx] = filePath;
    },
    // 更换链接弹窗
    showUrlDialog(item, idx) {
      if (idx == 0 && item.tab_symbol == 'home') return;
      this.editInfo = item;
      this.urlDialogVisible = true;
    },
    //  更改链接
    onUrlChange(event) {
      const { url } = event
      const originURL = url

      if (this.editInfo.hasOwnProperty('url')) {
        this.editInfo.url = originURL;
      } else if (this.editInfo.hasOwnProperty('tab_url')) {
        //默认模块特殊处理
        if (['/', '/category', '/ranking', '/user'].includes(originURL)) {
          this.$set(this.editInfo, 'tab_symbol', originURL.replace('/', '') || 'home')
        }
        //默认模块特殊处理
        // if (originURL == "/") {
        //   this.$set(this.editInfo, "tab_symbol", "home");
        // }
        // if (originURL == "/category") {
        //   this.$set(this.editInfo, "tab_symbol", "category");
        // }
        // if (originURL == "/ranking") {
        //   this.$set(this.editInfo, "tab_symbol", "ranking");
        // }
        // if (originURL == "/user") {
        //   this.$set(this.editInfo, "tab_symbol", "user");
        // }
        this.editInfo.tab_url = originURL;
      }
    },
    // 返回
    back() {
      this.$emit('back');
    },
    // 解析模板数据
    parseTemplateJson(template) {
      if (template.id == undefined) {
        this.isNew = true;
        return;
      }
      this.id = template.id;
      this.name = template.name;
      this.bottom_tab_list = JSON.parse(template.bottom_tab_list);
      this.headModuleData.toolbar_background_color =
        template.toolbar_background_color;
      const that = this;
      let tem = JSON.parse(template.value);
      // eslint-disable-next-line
      tem.map(arr => {
        arr = Object.assign(arr, that.templateParseList[arr.cmsModuleName]);
      });
      this.viewModuleList.push(...tem);
    },

    // 模板转换为app布局json
    templateToJson(viewModuleList) {
      let newJson = JSON.parse(JSON.stringify(viewModuleList));
      newJson.map((item) => {
        delete item.height;
        delete item.name;
        delete item.module;
        delete item.moduleType;
      });
      return newJson;
    },

    // 判断链接是否为空  拼图
    cheackPuzzleLink(list) {
      let err = false;
      list.map((arr) => {
        if (arr.moduleType == 'puzzle-module') {
          arr.items.map((item) => {
            if (item.url == '') {
              err = true;
            }
          });
        }
      });
      return err;
    },

    // 判断底部栏是否有空链接
    cheackNavLink(list) {
      let err = false;
      list.map((arr) => {
        if (arr.tab_url == '') {
          err = true;
        }
      });
      return err;
    },

    //  判断文案是否为空  拼图
    cheackText(list) {
      let err = false;
      list.map((arr) => {
        if (arr.moduleType == 'puzzle-module') {
          arr.items.map((item) => {
            if (item.title == '' || item.subTitle == '' || item.buyNow == '') {
              err = true;
            }
          });
        }
      });
      return err;
    },

    //保存||新增
    save() {
      if (this.name == '') return this.$message.error('请输入模板名称');
      if (this.cheackPuzzleLink(this.viewModuleList))
        return this.$message.error('拼图模块中链接不能为空');
      if (this.cheackText(this.viewModuleList))
        return this.$message.error('拼图模块中文案不能为空');
      if (this.cheackNavLink(this.bottom_tab_list))
        return this.$message.error('底部栏tab链接不能为空');

      //滚动到编辑视图顶部
      this.$refs.templatView.scrollTop = 0;
      const loading = this.$loading();
      const templateEl = document.getElementById('template_view');
      html2canvas(templateEl, {
        backgroundColor: null,
        useCORS: true,
        scale: 1,
      }).then(async(canvas) => {
        setTimeout(() => {
          loading.close();
        }, 300);
        this.imgUrl = canvas.toDataURL('image/png');
        const { data } = await pictureAdd({
          type: this.role == 'taoke' ? 'taobaoke' : 'admin',
          data: this.imgUrl,
          sid: getToken(),
        });
        if (data.error_code == 0) {
          this.thum_image = data.file.replace(/https:|http:/, 'http:');
          let param = {
            toolbar_background_color: this.headModuleData
              .toolbar_background_color,
            bottom_tab_list: JSON.stringify(this.bottom_tab_list),
            id: this.id,
            name: this.name,
            value: JSON.stringify(this.templateToJson(this.viewModuleList)),
            thum_image: this.thum_image,
          };
          const res = this.isNew
            ? await this.plugin_app_theme_add(param)
            : await this.plugin_app_theme_edit(param);
          if (res.data.error_code == 0) {
            this.$message.success(
              `${this.isNew ? '添加模板成功' : '修改模板成功'}`
            );
            this.back();
          } else {
            this.$message.error(res.data.error_message);
          }
        } else {
          this.$message.error(data.error_message);
        }
      });
    },

    //上移
    moveUp(idx) {
      if (idx == 0) return;
      this.changePosition(idx, idx - 1);
      this.$refs.templatView.scrollTop =
        this.$refs.templatView.scrollTop - this.viewModuleList[idx].height;
    },

    //下移
    moveDown(idx) {
      if (
        idx == this.viewModuleList.length - 1 ||
        this.viewModuleList[idx + 1].id == 'recommend'
      )
        return;
      this.changePosition(idx, idx + 1);
      this.$refs.templatView.scrollTop =
        this.$refs.templatView.scrollTop + this.viewModuleList[idx].height;
    },

    // 互换位置
    changePosition(idx1, idx2) {
      let tep1 = JSON.parse(JSON.stringify(this.viewModuleList[idx1]));
      let tep2 = JSON.parse(JSON.stringify(this.viewModuleList[idx2]));
      this.$set(this.viewModuleList, idx1, tep2);
      this.$set(this.viewModuleList, idx2, tep1);
    },

    // 编辑
    edit(idx) {
      if (idx == 'head_module') {
        this.editTemplate = this.headModuleData;
        return;
      }
      if (idx == 'nav_module') {
        this.editTemplate = this.navModuleData;
        return;
      }
      this.editTemplate = this.viewModuleList[idx];
    },

    //新增模块
    addModule(item, idx) {
      // 已有为你推荐列表则不能再添加推荐列表
      if (this.hasRecommend && item.id == 'recommend') return;
      this.activeModuleId = idx;
      this.$refs.templatView.scrollTop = 9999999;
      //  为你推荐保持在最下方
      if (item.id !== 'recommend' && this.hasRecommend) {
        if (
          (item.cmsModuleName == 'pdd_module' ||
            item.cmsModuleName == 'jd_module') &&
          this.hasShopModule() != -1
        ) {
          // 删除原有京东或拼多多
          if (this.viewModuleList[this.hasShopModule()] == this.editTemplate) {
            this.editTemplate = {};
          }
          this.viewModuleList.splice(this.hasShopModule(), 1);
          // 添加双拼模块
          this.viewModuleList.splice(
            this.viewModuleList.length - 1,
            0,
            JSON.parse(JSON.stringify(this.doubleModuleData))
          );
        } else {
          this.viewModuleList.splice(
            this.viewModuleList.length - 1,
            0,
            JSON.parse(JSON.stringify(item))
          );
        }
      } else {
        if (
          (item.cmsModuleName == 'pdd_module' ||
            item.cmsModuleName == 'jd_module') &&
          this.hasShopModule() != -1
        ) {
          // 删除原有京东或拼多多
          if (this.viewModuleList[this.hasShopModule()] == this.editTemplate) {
            this.editTemplate = {};
          }
          this.viewModuleList.splice(this.hasShopModule(), 1);
          // 添加双拼模块
          this.viewModuleList.push(
            JSON.parse(JSON.stringify(this.doubleModuleData))
          );
        } else {
          this.viewModuleList.push(JSON.parse(JSON.stringify(item)));
        }
      }

      this.$nextTick(() => {
        this.$refs.templatView.scrollTop = 9999999;
      });
      setTimeout(() => {
        this.activeModuleId = -1;
      }, 100);
    },

    // 删除
    del(idx) {
      this.$confirm('确定删除此模块？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          if (this.viewModuleList[idx] == this.editTemplate) {
            this.editTemplate = {};
          }
          this.viewModuleList.splice(idx, 1);
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },

    // 拼图模块更改图片
    changeImg(path, idx, data) {
      this.$set(this.editTemplate.items[data.idx].imgs, idx, path);
    },

    //  hover动画
    barMouseLeave() {
      this.hoverModuleId = -1;
    },
    barMouseenter(id) {
      this.hoverModuleId = id;
    },
  },
  async mounted() {
    // const { data } = await this.plugin_app_theme_list();
  },
};
</script>

<style lang="scss" scoped>
/* 滚动条样式 */
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background: #d8d8d8;
}
::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  border-radius: 10px;
  background: #f9f9f9;
}
.head {
  margin-bottom: 40px;
}
.breadcrumb {
  margin-top: 8px;
  font-size: 14px;
  line-height: 20px;
  display: inline-block;
  .new {
    display: inline-block;
    color: rgba(70, 73, 77, 1);
  }
  .tem {
    cursor: pointer;
    transition: all 0.2s;
    color: rgba(193, 201, 210, 1);
    .right {
      display: inline-block;
      margin-left: 5px;
      margin-right: 8px;
      font-size: 14px;
    }
    &:hover {
      color: $theme;
    }
  }
}
/deep/ .first {
  .el-breadcrumb__inner.is-link {
    cursor: pointer;
    color: #c1c9d2;
  }
  .el-breadcrumb__inner a:hover,
  .el-breadcrumb__inner.is-link:hover {
    color: #409eff;
  }
}
/deep/ .limit-input {
  width: 420px;
}
/deep/ .limit-input-box {
  margin-top: 2px;
  margin-bottom: 40px;
}

.pack {
  margin-top: 2px;
  margin-bottom: 12px;
  padding-top: 20px;
  padding-bottom: 0px;
}
.edit {
  position: relative;
  /deep/ .zt-button {
    float: right;
    width: 143px;
    height: 40px;
    margin-top: 4px;
    border-radius: 2px;
  }
  .tem-bar {
    display: inline-block;
    margin-right: 20px;
    margin-bottom: 20px;
    cursor: pointer;
    position: relative;
    transition: all 0.2s;
    width: 184px;
    height: 44px;
    border-radius: 2px;
    padding: 10px 20px;
    &:hover {
      border-color: transparent;
      color: $theme;
    }
    .bar-inner {
      transition: border-color 0.2s;
      border-radius: 2px;
      width: 100%;
      height: 100%;
      position: absolute;
      border: 1px solid rgba(228, 231, 237, 1);
      top: 0px;
      left: 0px;
      &:hover {
        border: 2px solid rgba(64, 158, 255, 1);
      }
    }
    .svg-icon {
      width: 20px;
      height: 20px;
      margin-top: 1px;
    }
    span {
      vertical-align: top;
      font-size: 16px;
      line-height: 23px;
      font-weight: 600;
      display: inline-block;
      margin-left: 6px;
    }
  }
  .tem-bar-active {
    background: $theme;
    border-color: $theme;
    color: #ffffff;
    &:hover {
      border-color: $theme;
      color: #ffffff;
    }
    .bar-inner {
      &:hover {
        border: none;
      }
    }
  }
}
// .edit-main{
//   display: flex;
//   flex-direction: row;
// }
.template-view {
  // flex: none;
  vertical-align: top;
  position: relative;
  background: #fafafa;
  display: inline-block;
  width: 377px;
  height: 649px;
  border-radius: 2px;
  border: 1px solid rgba(228, 231, 237, 1);
  .scoll-view {
    // padding-top: 10px;
    padding-bottom: 10px;
    position: relative;
    overflow: auto;
    height: 555px;
  }
}
.template-edit {
  vertical-align: top;
  display: inline-block;
  width: calc(100% - 397px);
  height: 649px;
  overflow: auto;
  margin-left: 20px;
  border: 1px solid rgba(235, 238, 245, 1);
  border-radius: 4px;
  padding: 21px 28px;
  .title {
    color: #232526;
    font-size: 18px;
    font-weight: 600;
    line-height: 25px;
    margin-bottom: 18px;
    .tips {
      float: right;
      margin-top: 5px;
      font-size: 12px;
      font-weight: 400;
      color: rgba(141, 146, 153, 1);
      line-height: 17px;
    }
  }
  hr {
    border-width: 0.5px 0px 0px 0px;
    border-style: solid;
    border-color: rgba(235, 238, 245, 1);
    margin-bottom: 18px;
  }
}
.head-edit {
  span {
    display: inline-block;
    vertical-align: middle;
    color: #232526;
    line-height: 20px;
    margin-right: 72px;
  }

  /deep/ .el-color-picker {
    vertical-align: middle;
  }
}
.pdd-edit {
  /deep/ .limit-input {
    width: 293px;
  }
  /deep/ .limit-input-box {
    margin-bottom: 0px;
  }
  /deep/ .el-form-item {
    margin-bottom: 8px;
  }
}
.puzzle-edit {
  p {
    font-size: 16px;
    font-weight: 600;
    color: rgba(35, 37, 38, 1);
    line-height: 22px;
    margin-bottom: 10px;
  }
  /deep/ .limit-input {
    width: 293px;
  }
  /deep/ .limit-input-box {
    margin-bottom: 0px;
  }
  /deep/ .el-form-item {
    margin-bottom: 8px;
  }
  .link-input {
    cursor: pointer;
    width: 293px;
    height: 40px;
    border-radius: 2px;
    border: 1px solid rgba(228, 231, 237, 1);
    padding: 0 15px;
    padding-right: 10px;
    .text {
      width: 245px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: inline-block;
    }
    .text-dis {
      color: #c0c4cc;
    }
    .svg-icon {
      color: #8d9299;
      margin-top: 8px;
      float: right;
    }
  }
  .upload-box {
    margin-top: 8px;
    margin-right: 20px;
    display: inline-block;
  }
  /deep/ .upload {
    margin-top: 4px;
    width: 98px;
    height: 98px;
    border-radius: 4px;
    border: 1px solid rgba(235, 238, 245, 1);
    .upload-btn {
      border-radius: 4px;
    }
    img {
      border-radius: 0;
    }
  }

  .puzzle-item {
    margin-top: 24px;
    padding-bottom: 17px;
    border-style: solid;
    border-width: 0 0 1px 0;
    border-color: rgba(235, 238, 245, 1);
    &:first-child {
      margin-top: 0;
    }
  }
}
.nav-edit {
  /deep/ .upload {
    display: inline-block;
    margin-top: 4px;
    width: 26px;
    height: 26px;
    .upload-btn {
      padding: 0px;
      width: 26px;
      height: 26px;
      border-radius: 4px;
    }
    img {
      width: 26px;
      height: 26px;
      border-radius: 0;
    }
  }
  text-align: center;
  /deep/ .el-table th {
    text-align: center;
    background: #ffffff;
    border: none;
  }
  /deep/ .el-table td,
  .el-table th {
    text-align: center;
    line-height: 20px;
    padding: 0px;
  }
  /deep/ .el-table td,
  .el-table th.is-leaf {
    border: none;
  }
  /deep/ .el-table .cell {
    padding: 8px 0px;
  }
  // /deep/ .el-table::before {
  //   display: none;
  // }
  /deep/ .limit-input-box {
    margin-bottom: 0;
    width: 100%;
  }
  /deep/ .limit-input {
    width: 100%;
    text-align: center;
    height: 40px;
    border-radius: 2px;
  }
  /deep/ .el-table__empty-text {
    display: none;
  }
  img {
    width: 28px;
    height: 28px;
  }
  .link {
    position: relative;
    cursor: pointer;
    text-align: left;
    padding: 0px 10px;
    padding-right: 35px;
    margin: 0 10px;
    height: 40px;
    line-height: 40px;
    border-radius: 2px;
    border: 1px solid rgba(228, 231, 237, 1);
    background: #ffffff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    .svg-icon {
      color: #8d9299;
      position: absolute;
      top: 10px;
      right: 10px;
    }
  }
  .disabled {
    cursor: not-allowed;
  }
  /deep/ .zt-button {
    float: none;
    margin-top: 14px;
    color: $theme;
    border-color: $theme;
    width: 88px;
    height: 36px;
    padding: 0px;
  }
  .del {
    /deep/ .zt-button {
      padding: 0px;
      border: none;
      width: 30px;
      height: 30px;
      color: #606266;
      margin-top: 0px;
      &:hover {
        color: $theme;
      }
    }
  }

  .dis {
    background: #f0f0f0;
    color: #8d9299;
    border-color: #f0f0f0;
  }
}
.double-edit {
  /deep/ .limit-input-box {
    margin: 0;
  }
}
</style>